<template>
  <v-app>
    <router-view />
    <GlobalDialog />
  </v-app>
</template>

<script lang="ts" setup>
import GlobalDialog from '@/components/GlobalDialog.vue'
</script>
